import React from 'react';
import { createBrowserHistory } from 'history';
import { Switch, Redirect, Route } from 'react-router-dom';

import * as Section from '../views/Payment/Sections';

import * as routes from '../settings/_routesSettings';

export const history = createBrowserHistory();

const PaymentRouter = () => (
  <Switch>
    <Redirect exact from={routes.PAYMENT} to={routes.PAYMENT_CART} />
    <Route path={routes.PAYMENT_PROCESSING} component={Section.Processing} />
    <Route path={routes.PAYMENT_CART} component={Section.Cart} />
    <Route path={routes.PAYMENT_CHECKOUT} component={Section.Checkout} />
    <Route path={routes.PAYMENT_RESPONSE} component={Section.Response} />
  </Switch>
);

export default PaymentRouter;